import {PRESCRIPTIONS_CONFIG} from '../config/prescriptions';
import {INCIDENT_PRESCRIPTION_STATUS, INCIDENT_TYPE_KEYS} from '../Constants';
import {GFDI_COLORS} from '../reducers/point_data_grass';
import {calculateFMC} from '../reducers/point_data_leaflet_80';
import {DEFAULT_WRF, FFDI_COLORS} from '../reducers/point_data_mcarthur_mk5';

const colors = {
  scale: { '0': 'rgba(173, 179, 245, 0.7)', '0.5': 'rgba(245, 179, 173, 0.7)', '1': 'rgba(245, 245, 173, 0.7)' },
  else: 'rgba(210, 245, 175, 0.7)'
};
const formatFn = (value) => typeof value === 'undefined' ? '' :
                            value < 0 ? '<' :
                            value === 0 ? '✗' :
                            value === 0.5 ? '~' : '✓';

export const VALUES_CONFIG = [
  { key: 'FFDI', displayName: 'McArthur FDI', colors: FFDI_COLORS, decPlaces: 1, nonFinal: true },
  { key: 'GFDI', displayName: 'Grass FDI', colors: GFDI_COLORS, decPlaces: 1, nonFinal: true },
  { key: 'D1FDI', displayName: 'Day 1 Max FDI', colors, formatFn },
  { key: 'D2FDI', displayName: 'Day 2 Max FDI', colors, formatFn },
  { key: 'TEMP', displayName: 'Temperature', colors, formatFn },
  { key: 'RH', displayName: 'Relative Humidity', colors, formatFn },
  { key: 'DP', displayName: 'Dew Point', colors, formatFn },
  { key: 'WND10', displayName: 'Wind speed at 10m', colors, formatFn },
  { key: 'WND1p5', displayName: 'Wind speed at 1.5m', colors, formatFn },
  { key: 'KBDI', displayName: 'KBDI', colors, formatFn },
  { key: 'FMC', displayName: 'Leaflet 80 FMC', colors, formatFn },
  { key: 'CURE', displayName: 'Curing', colors, formatFn }
];

export const calculateWithinPrescription = (wd, variables, key) => {
  const config = PRESCRIPTIONS_CONFIG[variables.prescription];
  if (config) {
    const variable_key = config[key].variable;
    if (typeof variable_key !== 'undefined') {
      const variable_value = _getVariable(wd, variables, variable_key);
      if (typeof variable_value !== 'undefined' && variable_value !== null) {
        return config[key].calcFn(variable_value);
      }
    }
  }
  return undefined;
};

const _getVariable = (wd, variables, variable_key) => {
  if (variable_key === 'FMC') {
    return calculateFMC(wd);
  }
  if (variable_key.startsWith('DIV_WRF_')) {
    const base_key = variable_key.substring(8);
    return variables.wind_reduction_factor ? (wd[base_key] / variables.wind_reduction_factor).toFixed(1) : wd[base_key];
  }
  return wd[variable_key];
};

export const incidentPrescriptionsLayerIsActive = (layers) => {
  return layers.some(l => l.active && l.id === INCIDENT_TYPE_KEYS.INCIDENT_PRESCRIPTIONS);
};

export const calcPrescriptionsHaloValue = (burn, wd) => {
  const variables = { prescription: burn.prescriptionId, wind_reduction_factor: DEFAULT_WRF };

  // Halos are calculated from the day 1 max FDI and max wind
  const d1fdiResult = calculateWithinPrescription(wd, variables, 'D1FDI');
  const wndResult = calculateWithinPrescription(wd, variables, 'D1WND10') ||
                    calculateWithinPrescription(wd, variables, 'D1WND1p5');

  if (d1fdiResult === undefined || d1fdiResult.na) {
    burn.prescriptionStatus = INCIDENT_PRESCRIPTION_STATUS.PRESCRIPTION_NOT_LOADED;
  } else {
    burn.d1fdiResult = d1fdiResult;
    burn.wndResult = wndResult;
    burn.prescriptionStatus = INCIDENT_PRESCRIPTION_STATUS.PRESCRIPTION_LOADED;
  }
};

export const toPrescriptionIcon = (val) => {
  return formatFn(val);
};



// WEBPACK FOOTER //
// ./src/utils/prescriptions_utils.js